import type { SVGProps } from 'react'
const SvgSyArrowRightSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.916 2c-1.67 0-3.158.525-4.228 1.521S2 5.973 2 7.664v8.67c0 1.691.617 3.146 1.688 4.143S6.247 22 7.916 22h8.168c1.67 0 3.158-.527 4.229-1.523C21.383 19.48 22 18.025 22 16.334v-8.67c0-1.687-.616-3.14-1.686-4.137S17.754 2 16.084 2zm0 1.5h8.168c1.357 0 2.45.418 3.207 1.123S20.5 6.331 20.5 7.664v8.67c0 1.338-.453 2.34-1.209 3.045s-1.85 1.121-3.207 1.121H7.916c-1.358 0-2.45-.417-3.207-1.121S3.5 17.672 3.5 16.334v-8.67c0-1.338.453-2.339 1.209-3.043S6.559 3.5 7.916 3.5"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M7.914 11.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8.172a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z" />
			<path d="M12.32 7.502a.75.75 0 0 0-.529.22.75.75 0 0 0 .002 1.061L15.023 12l-3.23 3.217a.75.75 0 0 0-.002 1.06.75.75 0 0 0 1.06.002l3.764-3.748a.75.75 0 0 0 0-1.062L12.852 7.72a.75.75 0 0 0-.532-.219" />
		</g>
	</svg>
)
export default SvgSyArrowRightSquare
